import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgLocation(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5206_12603)">
        <path
          d="M8.00437 8C8.41813 8 8.77083 7.85271 9.0625 7.55813C9.35417 7.26354 9.5 6.90937 9.5 6.49562C9.5 6.08187 9.35271 5.72917 9.05812 5.4375C8.76354 5.14583 8.40938 5 7.99563 5C7.58188 5 7.22917 5.14729 6.9375 5.44188C6.64583 5.73646 6.5 6.09063 6.5 6.50438C6.5 6.91813 6.64729 7.27083 6.94187 7.5625C7.23646 7.85417 7.59062 8 8.00437 8ZM8 14.0208C9.65278 12.5347 10.8993 11.1667 11.7396 9.91667C12.5799 8.66667 13 7.54861 13 6.5625C13 5.10417 12.5243 3.89583 11.5729 2.9375C10.6215 1.97917 9.43056 1.5 8 1.5C6.56944 1.5 5.37847 1.97917 4.42708 2.9375C3.47569 3.89583 3 5.10417 3 6.5625C3 7.54861 3.42014 8.66667 4.26042 9.91667C5.10069 11.1667 6.34722 12.5347 8 14.0208ZM8 16C5.81986 14.179 4.19146 12.4877 3.11479 10.926C2.03826 9.36424 1.5 7.90972 1.5 6.5625C1.5 4.70139 2.11806 3.14236 3.35417 1.88542C4.59028 0.628472 6.13542 0 7.98958 0C9.84375 0 11.3924 0.628472 12.6354 1.88542C13.8785 3.14236 14.5 4.70139 14.5 6.5625C14.5 7.90972 13.9653 9.36111 12.8958 10.9167C11.8264 12.4722 10.1944 14.1667 8 16Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_5206_12603">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(0 -1 1 0 0 16)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
